
export default {
  props: {
    heater: {
      type: Object,
      required: true
    }
  },

  computed: {
    getDocs() {
      return this.heater.documents.flatMap((doc) => doc.childs || [])
    }
  }
}
